import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAddressBook, faBank, faBook, faCamera, faCartShopping, faFileInvoice, faHome, faMoneyBill, faReceipt, faRightFromBracket, faShoppingCart, faTruckArrowRight, faUser, faUsers } from '@fortawesome/free-solid-svg-icons'
import { ActionCreators } from 'store/actionCreators';
import { useDispatch } from 'react-redux';
import swal from 'sweetalert';


export const BottomBar = () => {
    const dispatch = useDispatch();

    const confirmLogout = () => {
        swal({
            title: "Confirm logout",
            text: "Are you sure you want to logout?",
            icon: "warning",
            dangerMode: true,
            buttons: {
                default: { text: 'Cancel' },
                cancel: { text: 'Cancel' },
                confirm: { text: 'Logout' }
            }
        })
            .then((confirmLogout) => {
                if (confirmLogout === true) {
                    dispatch(ActionCreators.logout());
                }
            });
    }

    return (
        <>
            <nav className="navbar fixed-bottom bg-light w-100 d-block border-top">
                <div className="container d-flex justify-content-around text-center">
                    <li className="nav-link text-dark" title="Home">
                        <NavLink to="/">
                            <FontAwesomeIcon icon={faHome} color='black' />
                        </NavLink>
                        <div style={{ fontSize: "12px" }}>Home</div>
                    </li>
                    <li className="nav-link text-dark" title="Orders">
                        <NavLink to="/ledger">
                            <FontAwesomeIcon icon={faBook} color='black' />
                        </NavLink>
                        <div style={{ fontSize: "12px" }}>Ledger</div>
                    </li>
                    <li className="nav-link text-dark" title="Receipts">
                        <NavLink to="/customer-slip">
                            <FontAwesomeIcon icon={faCamera} color='black' />
                        </NavLink>
                        <div style={{ fontSize: "12px" }}>Slips</div>
                    </li>
                    <li className="nav-link text-dark" title="Logout">
                        <a onClick={confirmLogout} href="#">
                            <FontAwesomeIcon icon={faRightFromBracket} color='black' />
                        </a>
                        <div style={{ fontSize: "12px" }}>Logout</div>
                    </li>
                </div>
            </nav>
        </>
    )
};
